var _rect, _circle, _rect2, _circle2, _rect3, _circle3, _circle4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedDial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 63,
    viewBox: "0 0 81 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 12.5,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 15.5,
    r: 4,
    fill: "#E6EAEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 21.5,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 24.5,
    r: 4,
    fill: "#E6EAEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 30.5,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 33.5,
    r: 4,
    fill: "#E6EAEB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 45.5,
    r: 6,
    fill: "#80959B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8334 45.8333H58.8334V47.8333H58.1667V45.8333H56.1667V45.1666H58.1667V43.1666H58.8334V45.1666H60.8334V45.8333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedDial);
export default __webpack_public_path__ + "static/media/SpeedDial.e94763d7ff48933e644b5ec1520cac40.svg";
export { ForwardRef as ReactComponent };